import * as React from 'react';
import { IItemCardProps } from 'models/itemcard';
import { IProductListItemCard } from 'models/product/productlistitem';
import { setProductPictureUrl } from 'helpers/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IProductListItemCard;
	t?: (key: string, options?: any) => string;
}

class ShopDashboardProductItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { name, picture, totalActions } = this.props.item;

		return (
			<div className="shopDashboardProductItemCard">
				<div
					className="productPicture"
					style={{ backgroundImage: `url(${setProductPictureUrl(picture, false).src})`, width: '40px', height: '52px' }}
				/>
				<div className="productInfoWrapper">
					<div className="productItemName">{name}</div>
					<div className="productTotalActions">{totalActions}</div>
				</div>
			</div>
		);
	}
}

export { ShopDashboardProductItemCard };
